import axiosInstance from '../../../api/axiosConfig';

export default {
  vectorizeDocument: (id) => axiosInstance.post(`/ai/vectorize/document/${id}`),
  vectorizeProceeding: (id) => axiosInstance.post(`/ai/vectorize/proceeding/${id}`),
  chatWithDocument: (id, question, history) =>
    axiosInstance.post(`/ai/chat/document/${id}`, { question, history }),
  chatWithProceeding: (id, question, history) =>
    axiosInstance.post(`/ai/chat/proceeding/${id}`, { question, history }),

  // RAG conversation endpoints
  getOrCreateConversation: (mode, entityId) =>
    axiosInstance.post('/ai/conversations', { mode, entityId }),
  getConversationMessages: (conversationId) =>
    axiosInstance.get(`/ai/conversations/${conversationId}/messages`),
  chatWithConversation: (conversationId, question) =>
    axiosInstance.post(`/ai/conversations/${conversationId}/chat`, { question }),
};
